<template>
        <div>
            <!-- 头部 -->
            <div >
                <navigation ref="navigation"></navigation>
            </div>
            <!--中间主体-->
            <div class="gd_main w_1000">
                <!--轮播图/登录框-->
                <login></login>
                <!--广告banner-
                <div class="gd_banner"><router-link  target="_blank" :to="{ path: '/newsInfo?id=7571'}"><img src="../assets/img/banner1.jpg" width="970" height="83"></router-link></div>-->
                <!--资讯列表-->
                <div class="gd_news">
                    <newsSimpleList  :settings="latestSettings"></newsSimpleList>
                    <newsSimpleList  :settings="policiesAndRegulationsSettings"></newsSimpleList>
                    <div class="clear"></div>
                    <!--广告banner-->
                    <!--<div class="gd_banner"><router-link target="_blank" :to="{ path: '/newsInfo?id=7566'}"><img src="../assets/img/banner2.jpg" width="970" height="83"></router-link></div>
                    <div class="gd_banner"><router-link target="_blank" :to="{ path: '/newsInfo?id=7571'}"><img src="../assets/img/banner1.jpg" width="970" height="83"></router-link></div>-->
                    <newsSimpleList  :settings="noticeNewsSettings"></newsSimpleList>
                    <newsSimpleList  :settings="aboutSettings"></newsSimpleList>
                    <div class="clear"></div>
                </div>
                <!--友情链接-->
                <div class="gd_goodlink">
                    <span>友情链接：</span>
                    <a href="http://www.nhfpc.gov.cn/" target="_blank">中华人民共和国国家卫生健康委员会</a>
                    <a href="http://www.hebwst.gov.cn/index.do?templet=index" target="_blank">河北省卫生健康委员会</a>
                    <a href="http://www.chs.org.cn/" target="_blank"> 中国社区卫生协会</a>
                    <a href="http://www.ncwsxh.org/" target="_blank">中国农村卫生协会</a>
                </div>
            </div>
            <!--版权-->
            <footer1></footer1>
        </div>
</template>

<script>
    import  navigation from '../components/Navigation';
    import  footer1 from '../components/Footer1';
    import  login from '../components/Login';
    import  newsSimpleList from '../components/NewsSimpleList';

    export default {
        name: 'index',
        components: {
            footer1,
            navigation,
            login,
            newsSimpleList
        },
        data () {
            return {
                latestSettings: {//协会动态资讯参数
                    consultId: 59,
                    consultName: '协会动态',
                    publishState: 0,
                    publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
                    'displayPositionIds': [1, 3],
                    'notProjectIds': [8, 9],
                    'orderWeight': true,
                    orderPublishTime: true,
                    pageNum: 1,
                    pageSize: 8,
                    showPublishTime:true,
                    moreUrl:'/latestNews'
                },
                noticeNewsSettings: {//通知公告资讯参数
                    consultId: 61,
                    consultName: '通知公告',
                    publishState: 0,
                    publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
                    'displayPositionIds': [1, 3],
                    'notProjectIds': [8, 9],
                    'orderWeight': true,
                    orderPublishTime: true,
                    pageNum: 1,
                    pageSize: 8,
                    showPublishTime:true,
                    moreUrl:'/notice'
                },
                policiesAndRegulationsSettings: {//政策法规资讯参数
                    consultId: 60,
                    consultName: '政策法规',
                    publishState: 0,
                    publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
                    'displayPositionIds': [1, 3],
                    'notProjectIds': [8, 9],
                    'orderWeight': true,
                    orderPublishTime: true,
                    pageNum: 1,
                    pageSize: 8,
                    showPublishTime:true,
                    moreUrl:'/policiesAndRegulations'
                },
                aboutSettings: {//关于协会资讯参数
                    consultId: 62,
                    consultName: '关于协会',
                    publishState: 0,
                    publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
                    'displayPositionIds': [1, 3],
                    'notProjectIds': [8, 9],
                    'orderWeight': true,
                    orderPublishTime: true,
                    pageNum: 1,
                    pageSize: 8,
                    showPublishTime:true,
                    moreUrl:'/about'
                },
            }
        },

        mounted () {

        },
        methods: {

        }
    }
</script>

